import React from "react";

interface IntroContent {
  heading: string;
  paragraphs: React.ReactNode[];
}

const INTRO_CONTENT: Partial<Record<string, IntroContent>> = {
  hygieneh3: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H3)",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H3) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų and mokymo periodiškumo patvirtinimo“.",
      "Ši higienos norma nustato pagrindinius grožio paslaugų sveikatos saugos reikalavimus. Ji privaloma visiems Lietuvos Respublikos juridiniams ir fiziniams asmenims, projektuojantiems, statantiems, įrengiantiems, rekonstruojantiems statinius ir patalpas, kuriose teikiamos grožio paslaugos, paslaugų teikėjams bei kontroliuojančioms institucijoms.",
      <>
        <strong>H3 – Higienos pažymėjimas.</strong> Grožio paslaugas teikiantiems darbuotojams
      </>,
    ],
  },
  hygiene4: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H1)",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H1) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų and mokymo periodiškumo patvirtinimo“.",
      "Švietimo teikėjų, vykdančių asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, pedagoginiai darbuotojai, laisvieji mokytojai, vykdantys asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, auklėtojų padėjėjai, vaikų socialinės globos įstaigų socialiniai darbuotojai, socialiniai pedagogai, individualios priežiūros personalas.",
      <>
        <strong>H1 – Higienos pažymėjimas.</strong> Vaikų poilsio stovyklų, vaikų žaidimų patalpų
        darbuotojams
      </>,
    ],
  },
  hygiene3: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H2)",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H1) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų ir mokymo periodiškumo patvirtinimo“.",
      "Švietimo teikėjų, vykdančių asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, pedagoginiai darbuotojai, laisvieji mokytojai, vykdantys asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, auklėtojų padėjėjai, vaikų socialinės globos įstaigų socialiniai darbuotojai, socialiniai pedagogai, individualios priežiūros personalas.",
      <>
        <strong>H1 – Higienos pažymėjimas.</strong> Švietimo įstaigų darbuotojams – vaikų globos
        įstaigų darbuotojams
      </>,
    ],
  },
  hygiene1: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H3)",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H1) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų ir mokymo periodiškumo patvirtinimo“.",
      "Švietimo teikėjų, vykdančių asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, pedagoginiai darbuotojai, laisvieji mokytojai, vykdantys asmenų iki 18 metų ugdymą pagal formaliojo ir (ar) neformaliojo švietimo programas, auklėtojų padėjėjai, vaikų socialinės globos įstaigų socialiniai darbuotojai, socialiniai pedagogai, individualios priežiūros personalas.",
      <>
        <strong>H1 – Higienos pažymėjimas.</strong> Švietimo įstaigų darbuotojams – ikimokyklinių
        įstaigų darbuotojams
      </>,
    ],
  },
  hygiene2: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H4)",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H1) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų ir mokymo periodiškumo patvirtinimo“.",
      <>
        <strong>H1 – Higienos pažymėjimas.</strong> Švietimo įstaigų darbuotojams – mokyklų
        darbuotojams
      </>,
    ],
  },
  hygiene2en: {
    heading: "Mandatory Hygiene Skills Training (Code H1) - Specialised Training Programme Materials",
    paragraphs: [
      "The Mandatory Hygiene Skills Training Programme (Code H1) is established by Order No. V-69 of 28 January 2008 of the Minister of Health of the Republic of Lithuania, On the Approval of the Description of the Procedure for Mandatory Training and Certification in First Aid, Hygiene Skills, and the Effects of Alcohol, Narcotic and Psychotropic Substances, and Other Psychoactive Substances on Human Health, as well as the List of Professions and Fields of Activity Requiring Mandatory Health and/or First Aid Training, the Codes of Training Programmes, and the Frequency of Training.",
      "Teaching staff employed by education providers delivering formal and/or non-formal education programmes to persons under the age of 18; independent teachers providing formal and/or non-formal education to persons under the age of 18; teacher assistants; social workers employed in child social care institutions; social workers; social pedagogues; and individual care staff.",
    ],
  },
  hygieneh4: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO (KODAS H4) SPECIALIOSIOS PROGRAMOS MEDŽIAGA",
    paragraphs: [
      <>
        <strong>H4 – Higienos pažymėjimas.</strong> Soliariumų paslaugas teikiantys darbuotojai
      </>,
    ],
  },
  hygieneh7: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO (KODAS H7) SPECIALIOSIOS PROGRAMOS MEDŽIAGA",
    paragraphs: ["Skirta keleivinio transporto darbuotojams."],
  },
  hygieneh10: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO SPECIALIOSIOS PROGRAMOS MEDŽIAGA (KODAS H10)",
    paragraphs: [
      "H10 pažymėjimas (žalia korta)  yra privalomas visiems darbuotojams, tiesiogiai tvarkantiems maistą – nuo gamybos iki patiekimo. Mokymai būtini siekiant užtikrinti maisto saugą, laikytis teisės aktų reikalavimų ir apsaugoti vartotojus nuo galimų sveikatos rizikų.",
      <>
        <strong>H10 – Higienos pažymėjimas.</strong> Tiesiogiai maistą tvarkantiems darbuotojams
      </>,
    ],
  },
  hygieneh10en: {
    heading: "TRAINING MATERIAL FOR THE MANDATORY HYGIENE SKILLS PROGRAM (CODE H10)",
    paragraphs: [
      "The H10 Hygiene Certificate (commonly known as the Green Card) is required for all employees who are directly involved in handling food—from preparation to serving. This training is essential to ensure food safety, meet legal requirements, and protect consumers from potential health risks.",
      <>
        <strong>H10 – Hygiene certificate.</strong> Training for food handlers
      </>,
    ],
  },
  hygieneh11: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ (KODAS H11) SPECIALIOSIOS MOKYMO PROGRAMOS MEDŽIAGA",
    paragraphs: [
      "Privalomojo higienos įgūdžių specialioji programa (H11) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašas, mokymo programų kodų ir mokymo periodiškumo patvirtinimo“.",
      <>
        <strong>H11 – Higienos pažymėjimas.</strong> valymo paslaugas teikiantiems darbuotojams.
      </>,
    ],
  },
  hygieneh12: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO (KODAS H12) SPECIALIOSIOS PROGRAMOS MEDŽIAGA",
    paragraphs: [
      <>
        <strong>H12 – Higienos pažymėjimas.</strong> Skalbimą ir sausą (cheminį) valymą atliekantys
        darbuotojai
      </>,
    ],
  },
  hygieneh15: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO (KODAS H15) SPECIALIOSIOS PROGRAMOS MEDŽIAGA",
    paragraphs: [
      "Programa skirta su nuodingosiomis medžiagomis dirbantiems darbuotojams.",
      <>
        <strong>H15 – Higienos pažymėjimas.</strong> Su nuodingosiomis medžiagomis dirbantys
        darbuotojai
      </>,
    ],
  },
  hygienehb: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ (KODAS HB) MOKYMO PROGRAMOS MEDŽIAGA",
    paragraphs: [
      "Privalomojo higienos įgūdžių mokymo bendroji programa (HB) nustatyta Lietuvos Respublikos sveikatos apsaugos ministro 2008 m. sausio 28 d. įsakymu Nr. V-69 „Dėl Privalomųjų pirmosios pagalbos, higienos įgūdžių, alkoholio, narkotinių ir psichotropinių ar kitų psichiką veikiančių medžiagų vartojimo poveikio žmogaus sveikatai mokymų ir atestavimo tvarkos aprašo ir Asmenų, kuriems privalomas sveikatos ir (ar) pirmosios pagalbos mokymas, profesijų ir veiklos sričių sąrašo, mokymo programų kodų ir mokymo periodiškumo patvirtinimo“.",
      "Ši privalomojo higienos įgūdžių mokymo bendroji programa (programos kodas HB) skirta visiems asmenims, kurie pradeda dirbti ir kuriems numatytas privalomas higienos įgūdžių mokymas. Asmenys, kurių darbo funkcijos apima kelias veiklos sritis, bendrąją programą išklauso vieną kartą ir jos nekartoja.",
      <>
        <strong>HB pažymėjimas.</strong> Bendroji higienos įgūdžių programa darbuotojams
      </>,
    ],
  },
  hygienehben: {
    heading: "TRAINING MATERIAL FOR THE MANDATORY HYGIENE SKILLS PROGRAM (CODE HB)",
    paragraphs: [
      "The general program for mandatory hygiene skills (HB) is established by the Order No. V-69 of the Minister of Health of the Republic of Lithuania, dated 28 January 2008, “On the Description of the Procedure for Training and Certification in Mandatory First Aid, Hygiene Skills, Alcohol, Narcotic and Psychotropic or Other Psychoactive Substance Use Impact on Human Health, and on the Approval of the List of Professions and Activities for Persons Required to Undergo Health and/or First Aid Training, Training Program Codes, and Training Frequency.”",
      "This general mandatory hygiene skills training program (program code HB) is intended for all individuals starting work who are required to undergo mandatory hygiene skills training. Individuals whose job functions cover multiple areas of activity attend the general program only once and are not required to repeat it.",
      <>
        <strong>HB certificate</strong> General hygiene skills program
      </>,
    ],
  },
  hygienehbb: {
    heading: "PRIVALOMOJO HIGIENOS ĮGŪDŽIŲ MOKYMO (KODAS HBB) SPECIALIOSIOS PROGRAMOS MEDŽIAGA",
    paragraphs: [
      "Kam skirti šie mokymai?",
      <>
        <strong>HBB- Higienos pažymėjimas.</strong> Netiesiogiai maistą tvarkantiems darbuotojams
      </>,
    ],
  },
};

interface DashboardIntroProps {
  selectedProduct: string;
}

const DashboardIntro: React.FC<DashboardIntroProps> = ({ selectedProduct }) => {
  const intro = INTRO_CONTENT[selectedProduct];

  if (!intro) {
    return null;
  }

  return (
    <div className="dashboard__info">
      <h2 className="dashboard__heading">{intro.heading}</h2>
      {intro.paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </div>
  );
};

export default DashboardIntro;
